import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import UserTable from '../../components/UserTable/UserTable'
import { fetchUsers } from '../../Reducers/actions/userActions'
import "./Admin.scss"
import Icon from '../../components/Icon/Icon'

const Users = () => {
    const { is_users_fetch, session } = useSelector((state) => ({
        is_users_fetch: state.user.users && state.user.users.length > 0,
        session: state.auth.session
    }))
    const dispatch = useDispatch()

    useEffect(() => {
        console.log('Current session:', session)
        if (!is_users_fetch && session) {
            console.log('Fetching users...')
            dispatch(fetchUsers())
        }
    }, [dispatch, is_users_fetch, session])

    return (
        <div className='container-main'>
            <div className="content-header">
                <div className="header-left">
                    <Icon alias="person" width={24} height={24} color="#1a1a1a" />
            <h2>Users</h2>
                </div>
                <p className="header-subtitle">Manage user accounts and permissions</p>
            </div>
            <UserTable />
        </div>
    )
}

export default Users